import { RepasseProjecao } from '@/types/interfaces/RepasseProjecao'

const roundMoeda = (valor: number) => Math.round(valor * 100) / 100

const formatRepasseDate = (dataIso: string) => {
  const [ano, mes, dia] = dataIso.slice(0, 10).split('-')

  return `${dia}/${mes}/${ano}`
}

const sortRepassesByDataDesc = (repasses: RepasseProjecao[]) => [...repasses].sort((a, b) => b.data.localeCompare(a.data))

// O desconto total cai no último vencimento (M3); M1/M2 só antecipam a liquidação.
const getRepasseFinal = (repasses: RepasseProjecao[]): RepasseProjecao | null => {
  const [repasseFinal] = sortRepassesByDataDesc(repasses)

  return repasseFinal || null
}

const getCustoAntecipacao = (repasse: RepasseProjecao, valorSolicitado: number) => Math.max(0, roundMoeda(repasse.desconto - valorSolicitado))

export {
  formatRepasseDate,
  getCustoAntecipacao,
  getRepasseFinal,
  sortRepassesByDataDesc,
}
